import React, { useEffect, useState } from "react";
import { Card, Image, Form, Input, Button, Flex, message, Typography } from "antd";
import APIService from "../services/APIService"
import { connect } from "react-redux"
import { isLogin, setUserData, setCustomerData, setWallet, setBill, setProfit, setPermission, setWhiteLabelData } from "../actions"
import { LocalStorageService } from "../services/LocalStorage";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import { setBotcharge } from "../actions/botChargeAction";
import image from "../assets/loginImg.png"
import loginIcon from "../assets/loginIcon.png"
import LayerImage from "../assets/layer.webp"
import VecImage from "../assets/vec-img.webp"
import Logo from "../assets/logo.svg"
function Login({ isLogin, setUserData, setWhiteLabelData, isLoading, setCustomerData, setWallet, setBill, setProfit, setPermission, setBotcharge }) {
    const axiosService = new APIService();
    const { role } = useParams()
    const urlParams = new URLSearchParams(window.location.search);
    const whiteLabel = urlParams.get('white_label');
    const [wlData, setWlData] = useState(null);
    const [forgotPassword, setForgotPassword] = useState(false);
    const navigate = useNavigate()
    const onFinish = (val) => {
        axiosService.post('/auth/signin', {
            email: val.email,
            password: val.password,
            loginAs: role,
            whiteLabel
        })
            .then(res => {
                isLogin(true)
                setUserData(res.data)
                LocalStorageService.setItem("userToken", res.token)
                LocalStorageService.setItem("user", res.data)
                if (res?.data?.role === "SUBADMIN") {
                    setPermission(res?.permission)
                }
                if (res?.data?.role === "ADMIN" || res?.data?.role === "SUBADMIN") {
                    navigate('/pip-Grid/home')
                } else if (res?.data?.role === "MMP_ADMIN") {
                    navigate('/make-my-profit/home')
                } else if (res?.data?.role === "WHITE_LABEL") {

                    navigate('/wl/users')
                    setWhiteLabelData(res?.white_label)
                    setBill(res?.bill)
                } else {
                    navigate('/dashboard')
                    setCustomerData(res?.customer)
                    setWallet(res?.wallet)
                    setBill(res?.bill)
                    setProfit(res?.totalProfit || 0)
                    setBotcharge(res?.botCharge)
                }

            })
            .catch(e => {
                message.error(e.message || "Something went wrong")
                isLogin(false)
                setUserData(null)
            })
    };
    const forgotPasswordForm = (val) => {
        axiosService.post('/auth/forgot-password', val)
            .then(res => {
                message.success(res.message)
            })
            .catch(e => {
                message.error(e.message)
            })
    }
    useEffect(() => {
        if (whiteLabel) {
            fetchWhitelabel()
        }
    }, [whiteLabel])
    const fetchWhitelabel = () => {
        axiosService.get(`white-label/get/${whiteLabel}`)
            .then(res => {
                setWlData(res.data)
            })
            .catch(e => console.log(e))
    }
    return (
        <div className="auth-wrapper">
            <div className="auth-wrapper-col right">
                <div className="layer-image">
                    <img src={LayerImage} alt="LayerImage" />
                </div>
                <div className="all-content-top-alignment">
                    <div className="spacing-alignment">
                        <div className="button-design-layer right-alignment">
                            <button>Zero Trading Knowledge required</button>
                        </div>
                        <div className="button-design-layer ">
                            <button>Zero Experience required</button>
                        </div>
                        <div className="button-design-layer right-alignment">
                            <button>Zero monitoring required</button>
                        </div>
                        <div className="button-design-layer ">
                            <button>Zero Time Required</button>
                        </div>
                    </div>
                </div>
                <div className="vec-img">
                    <img src={VecImage} alt="VecImage" />
                </div>
            </div>
            <div className="auth-wrapper-col left">
                <div className="center-login">

                    <div className="logo-center">
                        <img src={Logo} alt="Logo" />
                    </div>
                    <div className="text-style">
                        <h2>
                            Log In
                        </h2>
                        <p>
                            Unlock Your Dashboard
                        </p>
                    </div>
                    {forgotPassword ? <Form
                        name="basic"
                        onFinish={forgotPasswordForm}
                        autoComplete="off"
                        layout="vertical"
                        className="login-form"
                    >
                        <div className="input-design">
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Enter Email!",
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </div>
                        <div className="forgot-password-text">
                            <span onClick={() => setForgotPassword(false)}>
                                Back to Login
                            </span>
                        </div>

                        <div className="button-design">
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={isLoading}
                                size="large"
                                className="login-btn"
                            >
                                Send Email
                            </Button>
                        </div>
                    </Form> : <Form
                        name="basic"
                        onFinish={onFinish}
                        autoComplete="off"
                        layout="vertical"
                        className="login-form"
                    >
                        <div className="input-design">
                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Enter Email!",
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </div>


                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Password!",
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <div className="forgot-password-text">
                            <span onClick={() => setForgotPassword(true)}>
                                Forgot Password?
                            </span>
                        </div>
                        <div className="button-design">
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={isLoading}
                                size="large"
                                className="login-btn"
                            >
                                Login
                            </Button>
                        </div>
                    </Form>}
                </div>
            </div>

        </div>
    );
}
const mapStateToProps = ({ loading }) => {
    const { isLoading } = loading
    return {
        isLoading
    }
}
const mapDispatchToProps = {
    isLogin,
    setUserData,
    setCustomerData,
    setWallet,
    setBill,
    setProfit,
    setPermission,
    setBotcharge,
    setWhiteLabelData
}
export default connect(mapStateToProps, mapDispatchToProps)(Login)